import React, { useState } from "react";
import {toast} from 'react-hot-toast'
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Grid,
  Paper,
  Container,
  MenuItem,
} from "@mui/material";
import Sidebar from "../user/sidebar";
import {useSelector} from 'react-redux'

const NewTransaction = () => {
  const navigate = useNavigate();
  const user = useSelector((state)=> state.user.buyer)
  const token = useSelector((state)=> state.user.token)
  const [loading, setLoading] = useState(false);
  const [transactionData, setTransactionData] = useState({
    opposite_user_id: "",
    amount: 0, // Initialize amount as a decimal (0.0)
    role: 0, // Initialize role as an integer (0 for Buyer)
  });

  console.log(transactionData)

  const handleInputChange = (e) => {
    const { name, value } = e.target;

      // Convert the value to an integer if it's the 'role' field
    const intValue = name === 'role' ? parseInt(value) : value;

    setTransactionData({
      ...transactionData,
      [name]: intValue,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)

  
    // Define the API endpoint
    const apiUrl = 'https://salama-api.onrender.com/transactions';
  
    // Prepare the request headers
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}` // Include the token in the Authorization header
    };
  
    // Prepare the request body
    const requestBody = JSON.stringify(transactionData);
    console.log(requestBody)
  
    // Make the POST request to the /transactions endpoint
    fetch(apiUrl, {
      method: 'POST',
      headers: headers,
      body: requestBody
    })
      .then(response => {
        if (!response.ok) {
          // Handle error responses here
          return response.json().then(errorData => {
            throw new Error(errorData.message || 'Network response was not ok');
          });
  
        } else {
            // Request was successful
            return response.json()
        }
      })
    .then(data => {
      // Handle the response data here
      console.log("Transaction Data:", data);
      setLoading(false)
      toast.success(data.message)
      transactionData.role === 1 ? navigate(`/contract/${data.contract_id}`) : navigate(`/user`)
    })
    .catch(error => {
      // Handle any errors that occurred during the fetch
      console.error('Error:', error);
      setLoading(false)
      toast.error(error.message)
      navigate('/account')
    });
  };
  

  return (
    <Container maxWidth="xl" style={{ display: "flex" }}>
      <Sidebar />
      <Paper
        elevation={3}
        style={{ flex: "1", padding: "2rem", minHeight: "calc(100vh - 150px)" }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Create a New Transaction
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
            <TextField
                fullWidth
                label={user?.email || "Email"} // Use optional chaining and provide a fallback
                name="email"
                variant="outlined"
                value={user?.email || ""}
                required
                InputProps={{
                  readOnly: true,
                }}    
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Buyer Id"
                name="opposite_user_id"
                variant="outlined"
                value={transactionData.opposite_user_id}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                label="Select Role"
                name="role"
                variant="outlined"
                value={transactionData.role}
                onChange={handleInputChange}
                required
              >
                <MenuItem value={0} >Buyer</MenuItem>
                <MenuItem value={1} >Seller</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Amount"
                name="amount"
                type="number"
                variant="outlined"
                value={transactionData.amount}
                onChange={handleInputChange}
                required
              />
            </Grid>

          </Grid>
          <Box mt={3}>
          <Typography variant="body2" color="textSecondary">
            Please note that a standard fee of Ksh 500 will be applied to this transaction.
          </Typography>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              disabled={loading}
            >
              { loading ? "loading..." : "Create Transaction" }
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default NewTransaction;
